import Rails from '@rails/ujs'

class PlayerLogger {
  /**
   *
   * @param {string} playKey
   * @param {string} extraKey
   * @param {string} ticketId
   */
  constructor(playKey, extraKey = undefined, ticketId = undefined) {
    this._playKey = playKey

    this._extraKey = extraKey

    /** @private {string} 空の場合、文字列で 'undefined' を渡す必要がある */
    this._ticketId = ticketId || 'undefined'

    this._previousLogUrl = null
  }

  createTime() {
    // 管理画面からの視聴の場合、ログの対象外
    if (PlayerLogger._isManager()) {
      return
    }

    if (this._extraKey) {
      Rails.ajax({
        url: '/extras/' + this._extraKey + '/create',
        type: 'POST',
      });

      return
    }

    const formData = new FormData()
    formData.append('play_key', this._playKey)
    formData.append('my_ticket', this._ticketId)

    Rails.ajax({
      url: '/play_logs',
      type: 'POST',
      data: formData,
      success: (response, status, xhr) => {
        this._previousLogUrl = xhr.getResponseHeader('Location')
      }
    })
  }

  updateTime(currentTime) {
    // 管理画面からの視聴の場合、ログの対象外
    if (PlayerLogger._isManager()) {
      return
    }

    if (this._extraKey) {
      Rails.ajax({
        url: '/extras/' + this._extraKey + '/update',
        type: 'PATCH'
      })

      return
    }

    if (this._previousLogUrl) {
      const formData = new FormData()
      // TODO: currentTime が Infinity になる可能性があるため、
      //     その場合に last_view_point パラメータの値が "Infinity" にならないようにする。
      //     一応、"Infinity" が送られても、バックエンドでエラーしないようにはしている。
      formData.append('last_view_point', currentTime)
      Rails.ajax({
        url: this._previousLogUrl,
        data: formData,
        type: 'PATCH'
      })
    }
  }

  static _isManager() {
    const brandPath = new RegExp('brand/plays/\\d')
    return brandPath.test(location.pathname)
  }
}

export default PlayerLogger
